export default {"src":"/_next/static/media/car25_64.1565917e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};